import { joinPaths } from './util';

export const HOMEPAGE_URL = 'https://www.indigo.app';
 // TODO: move media to indigo.app, but for now we can keep using media.useindigo.com for cloudfront
export const MEDIA_BASE_URL = 'https://media.useindigo.com';

export function getMediaUrl(path: string) {
  return joinPaths(MEDIA_BASE_URL, path);
}
